import { LinearProgress } from '@mui/material';
import type { FC } from 'react';

const LoadingScreen: FC = () => {
  return <LinearProgress />;
};

export default LoadingScreen;
